import { faDiscord, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faMapMarkerAlt, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AOS from 'aos';
import 'aos/dist/aos.css';
import emailjs from 'emailjs-com';
import React, { useEffect } from 'react';
import './ContactMe.css';

const ContactMe = () => {
  const emailSubmit = (e) =>{
    e.preventDefault();

    emailjs.sendForm('service_9at68re', 'template_lv2oomr', e.target, 'user_zdwna5wTnH8aghSI77RtQ')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  }

  useEffect(()=>{
    AOS.init({duration:1000});
  },[])
    return (
        <section data-aos="fade-left" className="paralax-mf footer-paralax bg-image sect-mt4 route">
      <div className="overlay-mf"></div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="contact-mf">
              <div id="contact" className="box-shadow-full">
                <div className="row">
                  <div className="col-md-6">
                    <div className="title-box-2">
                      <h5 className="title-left">
                        Send Message
                      </h5>
                    </div>
                    <div>
                      <form onSubmit={emailSubmit}>
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <div className="form-group">
                              <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" />
                              <div className="validate"></div>
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <div className="form-group">
                              <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" />
                              <div className="validate"></div>
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <div className="form-group">
                              <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" />
                              <div className="validate"></div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <textarea className="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
                              <div className="validate"></div>
                            </div>
                          </div>
                          <div className="col-md-12 text-center">
                            <button type="submit" className="button button-a button-big button-rouded">Send Message</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="title-box-2 pt-4 pt-md-0">
                      <h5 className="title-left">
                        Get in Touch
                      </h5>
                    </div>
                    <div className="more-info">
                      <p className="lead">
                        Feel free to knock me or you can also send me feedbacks. <br/> Happy Coding.
                      </p>
                      <ul className="list-ico">
                        <li><span><FontAwesomeIcon icon={faMapMarkerAlt}/> </span> 183/56 Kazi Villa, Bagbari, Sylhet, Bangladesh.</li>
                        <li><span><FontAwesomeIcon icon={faMobileAlt}/> </span> +8801686-823262 </li>
                        <li><span><FontAwesomeIcon icon={faEnvelope}/> </span> rafi.rahman03@gmail.com</li>
                      </ul>
                    </div>
                    <div className="socials">
                      <ul>
                        <li><a href="https://github.com/rahmanrafi32"><span className="ico-circle text-dark"><FontAwesomeIcon icon={faGithub}/></span></a></li>
                        <li><a href="https://www.linkedin.com/in/minhazur-rahman-rafi-7b3381159/"><span className="ico-circle text-dark"><FontAwesomeIcon icon={faLinkedin}/></span></a></li>
                        <li><a href="https://discord.com/channels/@467562311050067968"><span className="ico-circle text-dark"><FontAwesomeIcon  icon={faDiscord}/></span></a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    );
};

export default ContactMe;